export const experienceData = [
  {
    id: 0,
    company: "Asterdio",
    jobtitle: "Software Engineer",
    startYear: "Nov 2024",
    endYear: "Present",
  },
  {
    id: 1,
    company: "Kotuko",
    jobtitle: "Software Engineer",
    startYear: "May 2022",
    endYear: "Nov 2024",
  },
  {
    id: 2,
    company: "Bajra Technologies",
    jobtitle: "Associate Software Engineer",
    startYear: "Dec 2021",
    endYear: "Apr 2022",
  },
  {
    id: 3,
    company: "Anchor Digital Agency",
    jobtitle: "Software Developer",
    type: "Contract",
    startYear: "Dec 2021",
    endYear: "Dec 2022",
  },
  {
    id: 4,
    company: "AEON Soft Solutions",
    jobtitle: "Software Developer",
    startYear: "Jan 2021",
    endYear: "Nov 2021",
  },
  {
    id: 5,
    company: "AEON Soft Solutions",
    jobtitle: "Software Developer",
    type: "Internship",
    startYear: "Oct 2020",
    endYear: "Dec 2020",
  },
];
